import React, { useContext, useEffect, useState } from 'react';
import { groupBy } from '../../../../../../contrib/utils';

import { GlobalContext } from '../../../../../../store';
import { IFormat, IMetaFormatBluePrint } from '../../../../../../store/admin/roundFormats/store';

import { filterOptions } from '../../Utils/filterOptions';
import { Notify } from '../../Utils/Notify';
import { GameFormatSelectorSection } from '../GameFormatSelectorSection/GameFormatSelectorSection';
import { StyledGameFormatSelector } from './GameFormatSelector.Styles';

interface IGameFormatSelector {
  eventId: string;
  clubId: string;
  afterCreationCallback?: () => void;
}

export const GameFormatSelector = (props: IGameFormatSelector) => {
  const { clubId, eventId, afterCreationCallback } = props;

  const {
    actions: {
      adminEvents: { get: getEvent, edit: editAdminEvent },
      adminRoundFormats: { createRoundFormat },
      notifications: { push: pushNotification }
    },
    adminEvents,
    adminRoundFormats: { masterFormats }
  } = useContext(GlobalContext);

  const event = adminEvents[Number(eventId)];

  const rounds = event ? event.rounds : [];

  const roundsIds = new Set<number>(rounds.map(round => round.id));

  const [availableFormats, setAvailableFormats] = useState<IFormat[]>([]);

  const [formatGameOptions, setFormatGameOptions] = useState<IFormat[]>([]);
  const [formatContestOptions, setFormatContestOptions] = useState<IFormat[]>([]);

  useEffect(() => {
    setAvailableFormats(masterFormats);
  }, [masterFormats]);

  useEffect(() => {
    const gameFormats = filterOptions(availableFormats, false);
    const contestFormats = filterOptions(availableFormats, true);

    if (gameFormats.length !== formatGameOptions.length) {
      setFormatGameOptions(gameFormats);
    }

    if (contestFormats.length !== formatContestOptions.length) {
      setFormatContestOptions(contestFormats);
    }
  }, [availableFormats]);

  const addFormat = (formatId: number) => async () => {
    const formatToCreate: IMetaFormatBluePrint = {
      adjustedHandicap: false,
      aggregations: [1, 2],
      format: formatId,
      id: -1,
      metadata: {},
      relevantScores: 1,
      rounds: [...roundsIds],
      scoreTypes: [1, 2],
      strikes: 3
    };

    if (afterCreationCallback) {
      afterCreationCallback();
    }

    delete formatToCreate.id;

    const formatGamesById: { [id: string]: IFormat[] } = groupBy(formatGameOptions, 'id');
    const formatFormat = formatGamesById[formatToCreate.format]
      ? formatGamesById[formatToCreate.format][0]
      : null;

    if (
      !!formatFormat &&
      (formatFormat.name.toLowerCase().includes('team') ||
        formatFormat.name.toLowerCase().includes('scramble'))
    ) {
      editAdminEvent(clubId, { id: Number(eventId), playersPerTeam: 2 }).catch();
    }

    const response = await createRoundFormat(Number(clubId), eventId, formatToCreate);

    await getEvent(clubId, eventId, true);

    await Notify(response, 'Format created', pushNotification);
  };

  return (
    <StyledGameFormatSelector>
      <GameFormatSelectorSection type="Game" options={formatGameOptions} addFormat={addFormat} />

      <GameFormatSelectorSection
        type="Contest"
        options={formatContestOptions}
        addFormat={addFormat}
      />
    </StyledGameFormatSelector>
  );
};
